import Form from './form.vue';
import PositionTable from './components';
import CustomerPortrait from '../../customer_information/components/customer_portrait/index.vue';

export { Form, PositionTable, CustomerPortrait };
